
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { thirdRegister, getCode } from '@/services/http';
import { writeCookie, readCookie } from '@/tools/tools';
import { validateTelPhone } from '@/tools/regexp';
import Footer from '@/common/footer.vue';

@Component({
  components: {
    Footer
  }
})
export default class extends Vue {
  // 是否获取验证码
  isCode: boolean = false

  count: number = 60

  timer: any = null

  form: any = {
    mobileNo: '',
    smsCode: ''
  }

  rules: object = {
    mobileNo: [{ validator: validateTelPhone, trigger: 'blur' }],
    smsCode: [{ message: '请输入验证码', trigger: 'blur' }]
  }

  created() {}

  @Action('user/setUserInfoList') setUserInfoList!: Function

  @State('user') userinfor: any

  // 获取验证码
  private async getCode() {
    const res: any = await getCode({
      phone: this.form.mobileNo,
      src: 3
    });
    if (res.data.code === 100) {
      this.$message.success('手机验证码已经成功发送，请注意查收！');
      this.isCode = true;
      this.countDown();
    } else {
      this.$message.error(res.data.message);
    }
  }

  private async wxLoginCallBack() {
    // const form = this.$refs.form as any;
    // form.validate(async (valid: boolean) => {
    //   if (valid) {
    const res: any = await thirdRegister({
      mobileNo: this.form.mobileNo,
      smsCode: this.form.smsCode,
      wxOpenId: this.$route.query.wxOpenId,
      unionId: this.$route.query.unionId,
      headImage: this.$route.query.headImage,
      qqUnionId: this.$route.query.qqUnionId,
      nickName: this.$route.query.nickName,
      equip: '',
      model: '',
      equipVersion: '',
      version: '',
      equipMeid: ''
    });
    if (res.data.code === 100) {
      writeCookie('accessToken', res.data.data);
      await this.setUserInfoList();
      const anchor = readCookie('anchor');
      if (anchor) {
        const obj:any = {
          accessToken: res.data.data,
          userName: this.userinfor.userinfolist.nickName,
          userId: this.userinfor.userinfolist.id,
          userPhoto: this.userinfor.userinfolist.headImgUrl,
          macCode: '',
          phone: this.userinfor.userinfolist.phone
        };
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          delete obj.accessToken;
          obj.token = res.data.data;
          (this as any).webTransport.getUserLoginData(JSON.stringify(obj));
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          delete obj.accessToken;
          obj.token = res.data.data;
          (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
        } else {
          (window as any).JsIntrS.getUserLoginData(obj);
        }
      }
      const path: any = this.$route.query.redirect;
      if (path) {
        this.$router.push(path);
      } else {
        this.$router.push('/');
      }
    } else {
      this.$message.error(res.data.message);
    }
    //   }
    // });
  }

  // 比较版本
  compareVersion(v1: any, v2: any) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    // 调整两个版本号位数相同
    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);

      if (num1 > num2) {
        return 1;
      } if (num1 < num2) {
        return -1;
      }
    }

    return 0;
  }

  // 倒计时
  countDown() {
    this.timer = setInterval(() => {
      this.count -= 1;
      if (this.count <= 0) {
        clearInterval(Number(this.timer));
        this.isCode = false;
      }
    }, 1000);
  }
}
